export default __webpack_public_path__ + "images/FSA.10547759f8c2e4b32d088b1d6a3238d7.svg";